/**
 * @file: 快捷键监听
 * @author: xiaolong.huang@dmall.com
 */

import * as StageStatus from '../../stageStatus';
import ShortCutKey from '../../interaction/shortcutkey/index';
import ShortMove from '../../interaction/shortMove';

function init(): void {
    ShortCutKey.on({
        keyName: 'press+w',
        callback: (event) => {
            // 卧柜暂不支持
            if (StageStatus.isTopFace()) return;
            ShortMove.move('up');
        }
    });
    ShortCutKey.on({
        keyName: 'press+s',
        callback: (event) => {
            // 卧柜暂不支持
            if (StageStatus.isTopFace()) return;
            ShortMove.move('down');
        }
    });
    ShortCutKey.on({
        keyName: 'press+a',
        callback: (event) => {
            // 卧柜暂不支持
            if (StageStatus.isTopFace()) return;
            ShortMove.move('left');
        }
    });
    ShortCutKey.on({
        keyName: 'press+d',
        callback: (event) => {
            // 卧柜暂不支持
            if (StageStatus.isTopFace()) return;
            ShortMove.move('right');
        }
    });
}

export default {
    init
};
